import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { Link } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import { PropListItem } from "../CustomComponents/PropListItem";
import { logger } from '../../utils';

export default function TaskPropDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [TaskGroupChoices, setGroupChoices] = React.useState([])
	const [taskVariableChoices, setTaskVariableChoices] = React.useState([]);
	
    const setTaskGroup = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.GroupID }))
        setGroupChoices(choices)
    }

    const initialValues = {
        Name: '',
        IsActive: false,
        propList: []
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a name for this Group Name')
            .required('Name is required'),
        IsActive: Yup
            .boolean(),
        propList: Yup.array().of(
            Yup.object().shape({
                taskVariable: Yup.string().required("Task Variable is requried"),
            })
        )

    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.Name,
            IsActive: values.IsActive,
            PropList: values.propList
        };
        logger(values)

        if (checkPropList(values.propList)) {
            if (checkName(values.Name)) {
                callBack(msg)
            }
        }
        
        
    })

    const checkName = (Name) => {
        var conflict = false;
        TaskGroupChoices.forEach((item, index) => {
            logger("checkName", Name, item)
            if (item.label === Name) {
                setAlert(true);
                conflict = true;
                setAlertText("already have a Task Group with name");
                logger("return false", LockedAlert)
                
            }
        })
        logger("loop finished", LockedAlert)
        if (!conflict) {
            return true;
        } else {
            return false;
        }
    }

    const checkPropList = (propList) => {
        logger("checkPropList", propList)
        if (propList.length === 0) {
            setAlert(true);
            setAlertText("Please select atleast one Task Variable");
        }
        return propList.length > 0
    } 

    const callBack = (msg) => {
        logger("callBack", msg)
        if (!LockedAlert) {
            logger(LockedAlert)
            handleDialogCallback(msg);

            handleClose();
        }
    }

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setGroupChoices([])
        setTaskVariableChoices([])
        setAlert(false)
        setOpen(false);
    };

    const setTaskVariable = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setTaskVariableChoices(choices)
    }

    React.useEffect(() => {
        if (refresh) {

            fetch('/api/task_group', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setTaskGroup(json));

            fetch('api/task_variable', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setTaskVariable(json));

            setRefresh(false);
        }
    });
    
    const handleAlertClose = () => {
        setAlert(false);
    };

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Group
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                                onTrigger(values);
                                resetForm();
                           
                        }}
                    >
                        {props => (

                            <Form>                                
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Task Group
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Task Group Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name='Name'
                                            id="outlined-taskProp"                                
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                </div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>

                                <FieldArray name="propList">
                                    {({ push, remove }) => (
                                        <div>
                                            {props.values.propList.map((p, index) => {
                                                const taskVariable = `propList[${index}].taskVariable`;
                                                const touchedtaskVariable = getIn(props.touched, taskVariable);
                                                const errortaskVariable = getIn(props.errors, taskVariable);

                                                return (
                                                    <div key={p.id}>
                                                        <FormControl sx={{ m: 1, width: 240 }}>
                                                            <InputLabel>Task Variable</InputLabel>
                                                            <CustomSelect
                                                                name={taskVariable}
                                                                id="outlined-taskVariable"
                                                                labelId="outlined-taskVariable"
                                                                label="Task Variable"
                                                                options={taskVariableChoices}
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                value={p.taskVariable}
                                                                error={touchedtaskVariable && Boolean(errortaskVariable)}
                                                                helperText={touchedtaskVariable && props.errors.errortaskVariable}
                                                            />
                                                        </FormControl>

                                                        <Button                                                            
                                                            margin="normal"
                                                            type="button"
                                                            color="secondary"
                                                            variant="outlined"
                                                            onClick={() => remove(index)}
                                                        >
                                                            x
                                                        </Button>
                                                    </div>
                                                );
                                            })}
                                            <Button                                                
                                                type="button"
                                                variant="outlined"
                                                onClick={() =>
                                                    push({ id: props.values.propList.length, taskVariable: ""})
                                                }
                                            >
                                                Add
                                            </Button>
                                        </div>
                                    )}
                                </FieldArray>                            
                            </Form>
                        )}
                    </Formik>                    
                 </DialogContent> 
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Task Variable"
                    aria-describedby="Please Select Task Variable"
                >
                    <DialogTitle id="Task Variable">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>                              
            </Dialog>
        </div>
    );
}